<template lang="pug">
.text-muted Seats declared: {{data.constituencies.length}} out of {{data.constituenciesTotal}}
</template>

<script>
export default {
  computed: {
    // @NOTE handles only two levels deep
    data() {
      return (this.$parent.data ? this.$parent : this.$parent.$parent).data
    },
  }
}
</script>
